import { useQuery } from '@tanstack/react-query';
import { apiClientV2 } from '~/api/client';
import { CREATOR_BENCHMARKS } from '~/queries/keys';
import { CreatorBenchmarks } from '~/types';

export const useGetBenchmarksById = ({
  id,
  creatorId,
  shareToken,
}: {
  id: string;
  creatorId?: string;
  shareToken?: string;
}) => {
  return useQuery({
    queryKey: [CREATOR_BENCHMARKS, { id }],
    queryFn: () =>
      apiClientV2
        .get<CreatorBenchmarks>(`/benchmarks/${id}`, {
          headers: {
            'X-AUTH-TOKEN': shareToken,
            'X-AUTH-IMPERSONATE': creatorId,
          },
        })
        .then((r) => r.data),
    enabled: Boolean(id),
  });
};
